(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('docArticleMenu', {
        templateUrl: 'views/components/views/docArticleMenu/docArticleMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();